import http from "@/http/aisea/axios";
const resource = "/enterprises/operations";

export default {
  /**
   * APIでoperationの設定一覧を取得する
   * @returns {Promise<Object>}
   * @property {boolean} status - APIのリクエストが成功したかどうか
   * @property {number} code - ステータスコード
   * @property {Operation[]} data - データ
   * @property {string} message - メッセージ
   * @throws {Error}
   */
  index() {
    return http.get(`${resource}`);
  },
};
